import { render, staticRenderFns } from "./SocialEnquiryIcon.vue?vue&type=template&id=74955f8b&"
import script from "./SocialEnquiryIcon.vue?vue&type=script&lang=js&"
export * from "./SocialEnquiryIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports